<template>
    <div>
        <v-offline
            online-class="online"
            offline-class="offline"
            @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-sm-12 col-md-8">
                <h5 class="set_font_title">Owner/Clinic Map Report</h5>
            </div>
        </div>

        <div class="row setMarginTop">
            <div class="col">
                <p>Select Type</p>
                <el-select v-model="selectedType" @change="onTypeChange">
                    <el-option value="owner" label="Owner"></el-option>
                    <el-option value="clinic" label="Clinic"></el-option>
                </el-select>
            </div>
            <div class="col-md-3">
                <p>Select Date</p>
                <el-select v-model="dateFilterOption">
                    <el-option value="All">All</el-option>
                    <el-option value="Date Range">Date Range</el-option>
                </el-select>
            </div>
            <div class="col" v-if="dateFilterOption === 'Date Range'">
                <p>Select Date(s)</p>
                <v-md-date-range-picker
                    class="daterangepicker"
                    :presets="dateRangePresets"
                    :start-date="startDatePast"
                    :end-date="endDatePast"
                    @change="handleChange"
                    style="width:100% !important">
                </v-md-date-range-picker>
            </div>
            <div class="col">
                <p></p>
                <el-button @click="getMapReport" class="mt-4">Generate</el-button>
            </div>
        </div>
        <div class="row mt-5 card">
            <div class="col card-body">
                <MapBase
                    v-if="isDataLoaded"
                    :enableCluster="true"
                    :pins="markers"
                    :zoom="5"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VOffline from 'v-offline';
import {Button} from 'element-ui';
import VMdDateRangePicker from "v-md-date-range-picker";
import healthClinicService from "../../../../services/health-clinic.service";
import dateRangeDefaultPresetsMixin from '../../../../mixins/DateRangeDefaultPresetsMixin';
import MapBase from '../../../map/MapBase.vue';

Vue.use(VMdDateRangePicker);

export default {
    components: {
        [Button.name]: Button,
        VOffline,
        MapBase
    },
    props: {
        projectId: {
            type: String | Number
        },
    },
    data() {
        return {
            dateFilterOption: 'All',
            dateRangePresets: [],
            startDatePast: '',
            endDatePast: '',
            startDate: '',
            endDate: '',
            selectedType: 'owner',
            records: [],
            markers: [],
            center: {lat: 33.8291523, lng: -116.8004315},
            isDataLoaded: false
        }
    },
    mixins: [dateRangeDefaultPresetsMixin],
    methods: {

        getMapReport() {
            const vm = this;
            vm.markers = [];
            if (vm.dateFilterOption === 'All') {
                vm.startDate = '';
                vm.endDate = '';
            } else if (vm.startDate === '' || vm.endDate === '') {
                vm.startDate = vm.formatDate(vm.dateRangePresets[4].range[0]);
                vm.endDate = vm.formatDate(vm.dateRangePresets[4].range[1]);
            }
            const params = {
                type: vm.selectedType,
                start_date: vm.startDate,
                end_date: vm.endDate
            }

            const loading = vm.$loading({
                lock: true,
                text: 'Please wait generating users report...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            healthClinicService.getMapReport(vm.projectId, params)
            .then((apiResposne) => {
                if (!apiResposne.error.error_code) {
                    const records = apiResposne.data.records;
                    if (records.length) {
                        records.map((item) => {
                            const latLng = vm.selectedType === 'owner' ? `${item.owner.location_lat},${item.owner.location_lng}`.split(",")  : item.caught_location.split(",");
                            const latitude = latLng[0];
                            const longitude = latLng[1];
                            const iconUrl = item.animal.gender.toLowerCase() == 'male' ? 'https://hsapps-prod-media.s3.amazonaws.com/dog_markers/blue_dog.png' : 'https://hsapps-prod-media.s3.amazonaws.com/dog_markers/yellow_dog.png';
                            let obj = {
                                lat: parseFloat(latitude),
                                lng: parseFloat(longitude),
                                icon: iconUrl,
                                markerConfig: {
                                    iconUrl,
                                    popupConfig: {
                                        minWidth: 380
                                    }
                                },
                                popupText: `<div class="row"><div class="col-sm-12"><table><tr><td rowspan="10" style="padding:5px"><img src="${item.image_url}" height="150"></td></tr><tr><td>Gender:</td><td>${item.animal.gender}</td></tr><tr><td>Treatment:</td><td>${item.treatment || ''}</td></tr><tr><td>Deworming:</td><td>${item.deworming || ''}</td></tr><tr><td>Vaccination:</td><td>${item.vaccination_other || ''}</td></tr>${ vm.selectedType === 'owner' ? `<tr class="owner"><td colspan="2"><b>Owner Details</b></td></tr><tr><td>Name:</td><td>${item.owner.name || ''}</td></tr><tr><td>Mobile:</td><td>${item.owner.telephone_mobile || ''}</td></tr><tr><td>Locality:</td><td>${item.owner.google_locality || ''}</td></tr><tr><td>Address:</td><td>${item.owner.google_address || ''}${item.owner.google_postal_code ? ', ' + item.owner.google_postal_code : ''}</td></tr>` : '' }</table></div></div>`
                            }
                            vm.markers.push(obj);
                        });
                    }
                    vm.isDataLoaded = true;
                    if (vm.markers.length != 0) {
                        vm.center = vm.markers[0].postion;
                    }
                }
                loading.close();
            })
            .catch((error) => {
                loading.close();
            });
        },
        handleChange(values) {
            this.startDate = this.formatDate(values[0]._d);
            this.endDate = this.formatDate(values[1]._d);
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        onTypeChange() {
            this.getMapReport();
        }

    },
    async mounted() {
        const vm = this;

        vm.$store.dispatch("setScreenName", "Map Report");
        const date = new Date();
        vm.startDatePast = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-US');
        vm.endDatePast = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-US');
        vm.dateRangePresets = vm.getDateRangePresets();
        vm.getMapReport();
    }
}
</script>
<style scoped>
.owner {
    border-top: 1px solid;
}
.owner p {
    margin: 0;
}

.daterangepicker {
    z-index: 9999;
}
</style>
